import resource from '@api/resource';

/**
 * Returns the component for archive style reports sourced from our Google sheet
 */
function importArchiveGoogleComponent() {
  return import (/* webpackChunkName: "googleSheet" */ '@components/customReports/ArchiveGoogle');
}

export const state = {
  customReports: {
    archiveadm: importArchiveGoogleComponent,
    archivecrs: importArchiveGoogleComponent,
    archivedeg: importArchiveGoogleComponent,
    archiveenr: importArchiveGoogleComponent,
    archivefac: importArchiveGoogleComponent,
    archivetracking: importArchiveGoogleComponent,
    crr: () => import (/* webpackChunkName: "crr" */ '@components/customReports/CourseRegistratonReport'),
    crr01: () => import (/* webpackChunkName: "crr" */ '@components/customReports/CourseRegistratonReportLong'),
    crr_de: () => import (/* webpackChunkName: "crr" */ '@components/customReports/CourseRegistratonReportDistance'),
    crr_detail: () => import (/* webpackChunkName: "crr" */ '@components/customReports/CourseDetail'),
    crr_detail_unadj: () => import (/* webpackChunkName: "crr" */ '@components/customReports/CourseDetail'),
    crr_internal: () => import (/* webpackChunkName: "crr" */ '@components/customReports/CourseRegistratonReportInternal'),
    crr_subject: () => import (/* webpackChunkName: "crr" */ '@components/customReports/CourseRegistratonReportSubject'),
    conted: importArchiveGoogleComponent,
    financearch: importArchiveGoogleComponent,
    financeatt: importArchiveGoogleComponent,
    financetui: importArchiveGoogleComponent,
    hsbr: importArchiveGoogleComponent,
    modality: importArchiveGoogleComponent,
    mlco: importArchiveGoogleComponent,
    other: importArchiveGoogleComponent,
    peer: importArchiveGoogleComponent,
    enrproj: importArchiveGoogleComponent,
    standard: () => import (/* webpackChunkName: "reports" */ '@components/ReportStandard'),
    studentinfo: () => import (/* webpackPrefetch: true */ '@components/customReports/StudentLookup'),
    courseinfo: () => import (/* webpackPrefetch: true */ '@components/customReports/CourseLookup'),
    lowenrcls: () => import (/* webpackChunkName: "smallclass" */ '@components/customReports/LowEnrolledClasses'),
    ugfallapp: () => import (/* webpackPrefetch: true */ '@components/customReports/UGFallAppl'),
    oecampus: () => import (/* webpackChunkName: "oe" */ '@components/customReports/OECampus'),
    oesemester: () => import (/* webpackChunkName: "oe" */ '@components/customReports/OESemester'),
    oechar: () => import (/* webpackChunkName: "oe" */ '@components/customReports/OEChar'),
    oe: () => import (/* webpackChunkName: "oe" */ '@components/customReports/OE'),
    oemajor: () => import (/* webpackChunkName: "oe" */ '@components/customReports/OEMajor'),
    oear: () => import (/* webpackChunkName: "oe" */ '@components/customReports/OEAR'),
    admissionsdaily: () => import (/* webpackPrefetch: true */ '@components/customReports/AdmissionsOperational'),
    admissionsdaily_semester: () => import (/* webpackPrefetch: true */ '@components/customReports/AdmissionsOperationalSemester'),
    racecom: () => import (/* webpackChunkName: "studentsuccess" */ '@components/customReports/RaceCombinations'),
    facwat: () => import (/* webpackChunkName: "wat" */ '@components/FacultyWorkloadAssignmentTemplate'),
    fac00: () => import (/* webpackChunkName: "reports" */ '@components/ReportStandard'),
    modalitydaily: () => import (/* webpackChunkName: "reports" */ '@components/customReports/Modality'),
  },
  selectedFilters: {}
};

export const getters = {
  getCustomReport: state => key => state.customReports[key] || state.customReports.standard,
  getSelectedReportFilter: state => key => state.selectedFilters[key]
};

export const mutations = {
  setSelectedFilter: (state, { key, value }) => {
    state.selectedFilters[key] = value;
  }
};

/* Actions should always return a promise */
export const actions = {
  /**
   * selectedFilter should contain a key and value property
   */
  setSelectedFilter: async ({ commit }, { key, value }) => {
    commit('setSelectedFilter', { key, value });
  },
  getReportSpecs: (context, { reportId, config }) => {
    return resource.get(`${resource.BASE_API_PATH}/w/${resource.getReportApiPath(config.type)}/${reportId}/specs`, config);
  },
  getReportData: (context, { reportId, config }) => {
    return resource.get(`${resource.BASE_API_PATH}/w/${resource.getReportApiPath(config.type)}/${reportId}/data`, config);
  },
};

export default { state, getters, mutations, actions, namespaced: true };